import React from 'react'
import { Col } from 'antd'
import styled from 'styled-components'
import { TableRow } from 'Components/Shared/Table'
import { ReportLink as Link } from 'Components/AdminQC/Report/Components'
import { UnitByQCTypeItem } from 'features/adminReport/unit/types'
import { numberFormat } from 'utils/format'

type DefaultProps = {
  item: UnitByQCTypeItem
}

type Props = DefaultProps

const RowItem: React.FC<Props> = ({ item }) => {
  const { ProjectCode, Unit, QCTypeID, RequestID, CheckNumber } = item

  const renderData = (val: any, span: number = 2) => {
    return <Col span={span}>{val || '-'}</Col>
  }
  const path = `/report/unit/${ProjectCode}/${Unit}/${QCTypeID}/${CheckNumber}/${RequestID}`

  return (
    <RowModel>
      <Link to={path}>
        <TableRow minHeight={60} spaceBetweenRow={8} paddingLeft={24}>
          {renderData(<Bold>{item.QCTypeName}</Bold>)}
          {renderData(<TxtReg>{item.JobTypeName}</TxtReg>, 3)}
          {renderData(<TxtReg>{item.SubJobTypeName}</TxtReg>)}
          {renderData(<TxtReg>{item.DetailName}</TxtReg>)}
          {renderData(<TxtReg>{numberFormat(item.Score)}</TxtReg>)}
          {renderData(<TxtReg>{item.DefectCounter}</TxtReg>)}
          {renderData(<TxtReg>{numberFormat(item.TotalScore)}</TxtReg>)}
          {renderData(<TxtReg>{numberFormat(item.PercentOfDefect)} %</TxtReg>)}
          {renderData(
            <TxtReg>
              {item.ProjectCode}-{item.ProjectNameTH}
            </TxtReg>
          )}
          {renderData(
            <TxtReg>{item.IsSupplier ? 'Supplier' : 'ผู้รับเหมาหลัก'}</TxtReg>
          )}
          {renderData(<TxtReg>{item.Unit}</TxtReg>)}
        </TableRow>
      </Link>
    </RowModel>
  )
}

const RowModel = styled.div`
  cursor: pointer;
`
const Bold: any = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  color: #000;
  font-size: 20px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding-right: 5px;
`

const TxtReg = styled(Bold)`
  font-family: 'DB Helvethaica X 55 Regular';
`

export default RowItem
